/*
Возвращает текст сообщения на основании кода ошибки апи.
Применяется для замены текста сообщения, получаемого от сервера, на более подходящее для конечного пользователя.
Если возвращает null, то используется серверное сообщение.
*/
export function getApiErrorMessage (code) {
  let msg = null;
  switch (code) {
    case 10101:
      msg = 'Не нашли такой промокод. Проверьте ещё раз';
      break;
    case 10102:
      msg = 'Вы уже использовали этот промокод';
      break;
    case 10103:
      msg = 'Промокод нельзя применить. Проверьте условия акции';
      break;
  }
  return msg;
}
